export enum SkusTypes {
  SAVE_SKUS = 'SAVE_SKUS'
}
